<template>
  <div>
    <!-- POST APIに日程選択が必須であれば表示される日付選択コンポーネント -->
    <DialogSelectDate
      v-if="dateRequired"
      :request-code="code"
      @parentMethod="closeWindow"
    />

    <DialogQRFail ref="QRFail" :fail-title="failTitle" @clicked="closeWindow" />
  </div>
</template>

<script>
//　TODO CompositionAPIに書き換えたい
import API from "@/API";
import { mapGetters } from "vuex";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateVCH",
  data() {
    return {
      dateRequired: false,
      code: this.$route.query.code,
      failTitle: "読み込みがうまくいきませんでした",
    };
  },
  methods: {
    async VCH() {
      try {
        console.log("code 222:>> ", this.code);

        // ここではstart_date_conditionがreturnで帰ってくるのでtypeへ代入
        var type = (await API.getVoucherMasterBook(this.code))
          .start_date_condition;
      } catch (err) {
        // 失敗した場合はダイアログ
        this.$refs.QRFail.openDialog();
      }

      console.log("type :>> ", type);

      try {
        // そのtypeによって分岐("today","anytime","required")するが、現状today/anytimeのみ
        if (type == "today" || type == "anytime") {
          await this.postAPIBookGroupWithVoucher();
        } else if (type == "required") {
          // requiredは日付選択UIが必須
          this.dateRequired = true;
        }
      } catch (err) {
        console.log("err :>> ", err);
        // エラーの場合は400 bad_request 既に引換済み
        this.failTitle = "引き換え済みのコードです";
        this.$refs.QRFail.openDialog();
      }
    },
    // "today","anytime"の場合入力されたクーポンコードをパラメタータにPOST API
    async postAPIBookGroupWithVoucher() {
      try {
        // POST API
        await API.createBookGroupWithVoucher({
          code: this.code,
        });

        // 計測用 ネイティブコール
        await nativeHandlerService.ncCouponComplete(this.code16);

        this.redirectToBookBookingResult();
      } catch (err) {
        console.log("err :>> ", err);
        this.$refs.DialogLoading.closeDialog();
        // エラーハンドリングを行うこと
        switch (err.response.data.message) {
          case "引き換え可能期間外です":
            this.$refs.expiredCouponCode.openDialog();
            break;

          default:
            this.$refs.usedCouponCode.openDialog();
            break;
        }
      }
    },
    // 引き換え完了画面へのリダイレクト
    redirectToBookBookingResult() {
      this.$router.push({
        name: "BookBookingResult",
        params: {
          id: this.masterBook.id,
          book_group_id: this.bookGroup.id,
        },
        query: {
          voucher: true,
          language: this.$store.getters["common/lang"],
        },
      });
    },
    closeWindow() {
      nativeHandlerService.returnNativeAppTopPage();
    },
  },

  computed: {
    ...mapGetters("ticketing", ["bookGroup", "masterBook"]),
  },
};
</script>
